import bulmaIconpicker from "./bulma-iconpicker";

document.addEventListener("turbolinks:load", () => {
  bulmaIconpicker.attach();
});
